import { authHeader, client } from './client';

const WHATSAPP_CONVERSATION_URL = process.env.REACT_APP_WHATSAPP_CONVERSATION_URL;

class whatsappConversationDataService {
  static get(path = '', params, headers) {
    return client({
      method: 'GET',
      url: path,
      headers: { ...headers, ...authHeader() },
      params,
      baseURL: WHATSAPP_CONVERSATION_URL,
    });
  }

  static post(path = '', data = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: authHeader(),
      baseURL: WHATSAPP_CONVERSATION_URL,
    });
  }
}

export { whatsappConversationDataService };
